export default {"src":"//tokenlon.im/_next/static/media/mascot-longing.b3378da8.gif","height":200,"width":200};